import React from 'react';

/* Figma: White card section
   variant: 'default' (booking flow), 'padded' (mypage/list), 'auth' (login/signup), 'section' (admin detail)
   size: 'auto' (default), 'lg' (min-h 260px, reservation list)
   interactive: true adds hover shadow for clickable cards */
const variants = {
  default: 'px-4 py-5 sm:px-5',
  padded: 'p-5 sm:p-6 shadow-card',
  auth: 'p-6 sm:p-8 shadow-card',
  section: 'p-5 sm:p-6',
};

const sizes = {
  auto: '',
  lg: 'min-h-[260px]',
};

export default function Card({ children, variant = 'default', size = 'auto', interactive = false, className = '', ...props }) {
  return (
    <div
      className={`bg-white rounded-xl flex flex-col gap-4 ${variants[variant] || variants.default} ${sizes[size] || ''} ${interactive ? 'cursor-pointer hover:shadow-lg transition' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
